var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsteroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8DC6"
    },
    d: "M299.749,11.742l-77.882,90.955v17.067c61.454,0,112.558-44.293,123.142-102.695 C330.337,13.735,315.167,11.982,299.749,11.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77AAD4"
    },
    d: "M299.448,14.026l0.302-2.285c-58.797-0.918-121.255,20.48-173.916,63.118 c22.958,27.444,57.454,44.904,96.034,44.904v-17.067C260.028,102.697,292.656,65.405,299.448,14.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5C6E3"
    },
    d: "M494.891,206.69C505.647,191.743,512,173.419,512,153.6c0-45.912-33.997-83.863-78.186-90.104 c-20.976-19.553-45.61-33.467-72.293-41.925c0.093-0.486,0.192-0.971,0.281-1.459c1.68-9.274-4.476-18.156-13.75-19.837 c-9.272-1.677-18.156,4.476-19.837,13.75c-2.119,11.688-6.086,22.637-11.543,32.594L207.364,489.382 C223.388,503.452,244.379,512,267.378,512c40.447,0,74.712-26.39,86.568-62.884c13.499-8.248,26.567-17.77,39.047-28.49 c11.856,1.562,24.279-2.203,33.388-11.312c9.696-9.696,13.345-23.149,10.95-35.674C476.28,322.475,495.807,262.905,494.891,206.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2E3F1"
    },
    d: "M460.07,227.363c4.504-53.408-11.71-101.517-45.658-135.465 c-25.428-25.427-59.593-41.136-97.74-45.279c-18.528,33.811-54.395,56.078-94.805,56.078c-32.091,0-62.322-14.138-82.944-38.788 c-6.047-7.231-16.813-8.187-24.04-2.139c-7.229,6.047-8.187,16.811-2.139,24.04c0.046,0.055,0.092,0.107,0.138,0.16 c-3.736,3.385-7.419,6.872-11.033,10.486c-13.468,13.468-25.347,27.833-35.648,42.808C27.308,155.629,0,194.091,0,238.933 c0,21.55,6.309,41.624,17.177,58.484c1.476,51.202,19.973,99.436,56.274,135.739c35.871,35.871,83.389,54.369,133.913,56.227 c64.839-20.438,126.908-57.311,178.653-109.056C429.085,337.259,455.383,282.936,460.07,227.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8DC6"
    },
    d: "M267.378,364.089v113.778c31.419,0,56.889-25.47,56.889-56.889S298.796,364.089,267.378,364.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77AAD4"
    },
    d: "M290.133,420.978c0-31.419-10.188-56.889-22.756-56.889c-31.419,0-56.889,25.47-56.889,56.889 s25.47,56.889,56.889,56.889C279.946,477.867,290.133,452.397,290.133,420.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8DC6"
    },
    d: "M420.978,96.711v113.778c31.419,0,56.889-25.47,56.889-56.889S452.396,96.711,420.978,96.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77AAD4"
    },
    d: "M443.733,153.6c0-31.419-10.188-56.889-22.756-56.889c-31.419,0-56.889,25.47-56.889,56.889 s25.47,56.889,56.889,56.889C433.546,210.489,443.733,185.019,443.733,153.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A5C6E3"
    },
    cx: 256,
    cy: 256,
    r: 8.533
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A5C6E3"
    },
    cx: 290.133,
    cy: 221.867,
    r: 8.533
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A5C6E3"
    },
    cx: 381.156,
    cy: 329.956,
    r: 8.533
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A5C6E3"
    },
    cx: 142.222,
    cy: 432.356,
    r: 8.533
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8DC6"
    },
    d: "M108.089,164.978v147.911c40.844,0,73.956-33.112,73.956-73.956S148.933,164.978,108.089,164.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77AAD4"
    },
    d: "M147.911,238.933c0-40.844-17.829-73.956-39.822-73.956c-40.844,0-73.956,33.112-73.956,73.956 s33.112,73.956,73.956,73.956C130.082,312.889,147.911,279.777,147.911,238.933z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsteroid);
export default __webpack_public_path__ + "static/media/asteroid.1f9a2fe6eb9305cb3a13a456400bc07e.svg";
export { ForwardRef as ReactComponent };